import { createSelector } from "reselect";
import get from "lodash/get";
import { guestOrderSelector, orderDetailsSelector } from "ducks/selectors";
import moment from "moment";

const changeNumberDomain = state =>
  get(state, "form.ChangeNumberForm.values", {});

// ***************************************************************
// ************** ChangeNumberForm selectors ******************
// ***************************************************************

export const changeNumberSelector = createSelector(
  changeNumberDomain,
  changeNumber => changeNumber
);

// ***************************************************************
// ************** ChangeNumberForm makeSelect *****************
// ***************************************************************

export const makeSelectChangeNumberInitialValues = () =>
  createSelector(
    changeNumberSelector,
    orderDetailsSelector,
    (changeNumberForm, orderDetails) => {
      return {
        oldNumber: get(changeNumberForm, "oldNumber"),
        doc_type: { value: get(orderDetails, "doc_type") }
      };
    }
  );

export const makeSelectChangeNumberForm = () => changeNumberSelector;

export const makeSelectOldNumber = () =>
  createSelector(changeNumberSelector, changeNumberForm => {
    return get(changeNumberForm, "oldNumber");
  });

export const makeSelectNewNumber = () =>
  createSelector(changeNumberSelector, changeNumberForm => {
    return get(changeNumberForm, "selectedNumber.number");
  });

export const makeSelectFormattedChangeNumberDate = () =>
  createSelector(
    orderDetailsSelector,
    changeNumberSelector,
    (orderDetails, changeNumberForm) => {
      let selectedChangeNumberDate =
        get(orderDetails, "scheduled_date", "") ||
        get(changeNumberForm, "selectedChangeNumberDate", "");

      const momentDateObj = moment(new Date(selectedChangeNumberDate)); //add a check here, AU return non standard datetime like "2PM, 15 Jul 2021". If cant be formatted, we return raw value.
      const formattedDate = momentDateObj.isValid()
        ? momentDateObj.format("hA DD/MM/YYYY")
        : selectedChangeNumberDate;

      return formattedDate;
    }
  );

export const makeSelectSubmitChangeNumberFormPayload = () =>
  createSelector(
    changeNumberSelector,
    guestOrderSelector,
    (changeNumberForm, guestOrderDetail) => {
      return {
        scheduled_date: get(changeNumberForm, "selectedChangeNumberDate"),
        selected_new_number: get(changeNumberForm, "selectedNumber"),
        old_number: get(changeNumberForm, "oldNumber"),
        order_ref: get(guestOrderDetail, "order_ref"),
        nric: get(changeNumberForm, "nric")
      };
    }
  );
